import { Box, FormField, FillPreview, Divider } from '@wix/design-system';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { PollData_Design_PollDesign_Background_Type } from 'ricos-schema/next';
import { ThumbnailPicker, SliderWithInput } from 'wix-rich-content-ui-components';
import { POLL_BACKGROUND_COLOR, POLL_BACKGROUND_GRADIENT, POLL_BACKGROUND_IMAGE, POLL_CORDER_RADIUS_SLIDER, POLL_CORDER_RADIUS_INPUT, ANSWERS_CORNER_RADIUS_SLIDER, ANSWERS_CORNER_RADIUS_INPUT } from '../../dataHooks.js';
import { BACKGROUND_PRESETS } from '../../defaults.js';
import { Section } from './section.js';
import { ColorIcon } from '../../assets/icons/ColorIcon.js';
import { GradientIcon } from '../../assets/icons/GradientIcon.js';
import { ImageIcon } from '../../assets/icons/ImageIcon.js';
import 'ricos-schema';
import '../../helpers.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'wix-rich-content-editor-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DesignSettingsSection = ({
  componentData,
  updateRicosDocument
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { t } = useContext(RicosContext);
  const backgroundType = ((_c = (_b = (_a = componentData.design) == null ? void 0 : _a.poll) == null ? void 0 : _b.background) == null ? void 0 : _c.type) || PollData_Design_PollDesign_Background_Type.COLOR;
  const handlePollBorderRadiusChange = (borderRadius) => {
    var _a2;
    updateRicosDocument({
      design: __spreadProps(__spreadValues({}, componentData.design), {
        poll: __spreadProps(__spreadValues({}, (_a2 = componentData.design) == null ? void 0 : _a2.poll), { borderRadius })
      })
    });
  };
  const handleOptionBorderRadiusChange = (borderRadius) => {
    var _a2;
    updateRicosDocument({
      design: __spreadProps(__spreadValues({}, componentData.design), {
        options: __spreadProps(__spreadValues({}, (_a2 = componentData.design) == null ? void 0 : _a2.options), { borderRadius })
      })
    });
  };
  const handleBackgroundChange = (backgroundType2) => {
    var _a2;
    const backgroundPreset = BACKGROUND_PRESETS[backgroundType2][0];
    const bgValue = backgroundType2 === PollData_Design_PollDesign_Background_Type.GRADIENT ? { gradient: JSON.parse(backgroundPreset) } : backgroundType2 === PollData_Design_PollDesign_Background_Type.IMAGE ? { image: { src: { url: backgroundPreset } } } : { color: backgroundPreset };
    updateRicosDocument({
      design: __spreadProps(__spreadValues({}, componentData.design), {
        poll: __spreadProps(__spreadValues({}, (_a2 = componentData.design) == null ? void 0 : _a2.poll), {
          background: __spreadProps(__spreadValues({}, bgValue), { type: backgroundType2 })
        })
      })
    });
  };
  const handleBackgroundColorChange = (value) => {
    var _a2;
    const bgValue = backgroundType === PollData_Design_PollDesign_Background_Type.GRADIENT ? { gradient: JSON.parse(value) } : backgroundType === PollData_Design_PollDesign_Background_Type.IMAGE ? { image: { src: { url: value } } } : { color: value };
    updateRicosDocument({
      design: __spreadProps(__spreadValues({}, componentData.design), {
        poll: __spreadProps(__spreadValues({}, (_a2 = componentData.design) == null ? void 0 : _a2.poll), {
          background: __spreadProps(__spreadValues({}, bgValue), { type: backgroundType })
        })
      })
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Section, { title: t("Poll_PollSettings_Tab_Design_Section_Background_Header") }, /* @__PURE__ */ React.createElement(
    ThumbnailPicker,
    {
      dataSource: [
        {
          dataHook: POLL_BACKGROUND_COLOR,
          value: PollData_Design_PollDesign_Background_Type.COLOR,
          label: t("Poll_PollSettings_Tab_Design_Section_Background_Color"),
          renderBackgroundImage: (props) => /* @__PURE__ */ React.createElement(ColorIcon, __spreadValues({}, props))
        },
        {
          dataHook: POLL_BACKGROUND_GRADIENT,
          value: PollData_Design_PollDesign_Background_Type.GRADIENT,
          label: t("Poll_PollSettings_Tab_Design_Section_Background_Gradient"),
          renderBackgroundImage: (props) => /* @__PURE__ */ React.createElement(GradientIcon, __spreadValues({}, props))
        },
        {
          dataHook: POLL_BACKGROUND_IMAGE,
          value: PollData_Design_PollDesign_Background_Type.IMAGE,
          label: t("Poll_PollSettings_Tab_Design_Section_Background_Pattern"),
          renderBackgroundImage: (props) => /* @__PURE__ */ React.createElement(ImageIcon, __spreadValues({}, props))
        }
      ],
      selectedValue: backgroundType,
      title: t("Poll_PollSettings_Tab_Design_Section_Background_Choose"),
      onChange: handleBackgroundChange
    }
  )), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", marginTop: "SP3", marginBottom: "SP2" }, /* @__PURE__ */ React.createElement(FormField, { label: t(PICK_BACKGROUND_LABELS[backgroundType]) }, /* @__PURE__ */ React.createElement(Box, { marginTop: "SP2", marginBottom: "SP2", gap: "SP2", verticalAlign: "middle" }, BACKGROUND_PRESETS[backgroundType].map((color, index) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j, _k, _l, _m, _n;
    return /* @__PURE__ */ React.createElement(Box, { width: "36px", key: index }, /* @__PURE__ */ React.createElement(
      FillPreview,
      {
        selected: color === ((_c2 = (_b2 = (_a2 = componentData.design) == null ? void 0 : _a2.poll) == null ? void 0 : _b2.background) == null ? void 0 : _c2.color) || color === ((_h2 = (_g2 = (_f2 = (_e2 = (_d2 = componentData.design) == null ? void 0 : _d2.poll) == null ? void 0 : _e2.background) == null ? void 0 : _f2.image) == null ? void 0 : _g2.src) == null ? void 0 : _h2.url) || color === JSON.stringify((_k = (_j = (_i2 = componentData.design) == null ? void 0 : _i2.poll) == null ? void 0 : _j.background) == null ? void 0 : _k.gradient),
        onClick: () => {
          handleBackgroundColorChange(color);
        },
        fill: ((_n = (_m = (_l = componentData.design) == null ? void 0 : _l.poll) == null ? void 0 : _m.background) == null ? void 0 : _n.type) === "GRADIENT" ? gradientColorObjToString(JSON.parse(color)) : color
      }
    ));
  })))), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(Section, { title: t("Poll_PollSettings_Tab_Design_Section_CornerRadius_Header") }, /* @__PURE__ */ React.createElement(Box, { marginTop: "SP2", marginBottom: "SP2" }, /* @__PURE__ */ React.createElement(
    SliderWithInput,
    {
      min: 0,
      max: 20,
      label: t("Poll_PollSettings_Tab_Design_Section_CornerRadius_Poll"),
      onChange: handlePollBorderRadiusChange,
      value: (_f = (_e = (_d = componentData.design) == null ? void 0 : _d.poll) == null ? void 0 : _e.borderRadius) != null ? _f : 0,
      sliderDataHook: POLL_CORDER_RADIUS_SLIDER,
      inputDataHook: POLL_CORDER_RADIUS_INPUT
    }
  )), /* @__PURE__ */ React.createElement(Box, { marginTop: "SP2", marginBottom: "SP2" }, /* @__PURE__ */ React.createElement(
    SliderWithInput,
    {
      min: 0,
      max: 10,
      label: t("Poll_PollSettings_Tab_Design_Section_CornerRadius_Answers"),
      onChange: handleOptionBorderRadiusChange,
      value: (_i = (_h = (_g = componentData.design) == null ? void 0 : _g.options) == null ? void 0 : _h.borderRadius) != null ? _i : 0,
      sliderDataHook: ANSWERS_CORNER_RADIUS_SLIDER,
      inputDataHook: ANSWERS_CORNER_RADIUS_INPUT
    }
  ))));
};
const PICK_BACKGROUND_LABELS = {
  [PollData_Design_PollDesign_Background_Type.COLOR]: "Poll_PollSettings_Tab_Design_Section_Background_Color_Pick",
  [PollData_Design_PollDesign_Background_Type.IMAGE]: "Poll_PollSettings_Tab_Design_Section_Background_Pattern_Pick",
  [PollData_Design_PollDesign_Background_Type.GRADIENT]: "Poll_PollSettings_Tab_Design_Section_Background_Gradient_Pick"
};
const gradientColorObjToString = (gradient) => {
  return `linear-gradient(${gradient == null ? void 0 : gradient.angle}deg, ${gradient.startColor} 0%, ${gradient.lastColor} 100%)`;
};

export { DesignSettingsSection };
//# sourceMappingURL=design-settings-section.js.map
